import styled, { css } from "styled-components";
import { ColorsDomains } from "../../theme/styled";
import customMedia from "../../config/breakpoints";

export const DomainCardContainer = styled.div<{
  color: string;
  disabled?: boolean;
  isActive: boolean;
}>`
  display: flex;
  border-width: ${({ isActive }) => (isActive ? "4px" : "1px")};
  border-style: solid;
  border-color: ${({ theme, isActive, color }) =>
    isActive
      ? theme.colors.domains[color as keyof ColorsDomains]
      : theme.colors.grey100};
  align-items: center;
  padding: 40px;
  border-radius: 4px;
  transition: all 0.3s ease;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};

  ${customMedia.lessThan("mobile")`
    flex-direction:column;
  `}

  &:hover {
    border: 4px solid
      ${({ theme, color }) =>
        theme.colors.domains[color as keyof ColorsDomains]};
  }

  ${({ disabled }) =>
    disabled &&
    css`
      border: none;
      opacity: 0.2;
      &:hover {
        border: none;
      }
    `}
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 80%;

  ${customMedia.lessThan("tablet")`
    width:70%;
`}

  ${customMedia.lessThan("mobile")`
    width:100%;
  `}
`;

export const BoutonContainer = styled.div`
  width: 20%;
  display: flex;
  justify-content: flex-end;
  border: none;

  ${customMedia.lessThan("tablet")`
    width:30%;
  `}

  ${customMedia.lessThan("mobile")`
    justify-content: flex-start;
    width:100%;
    margin-top:16px;
  `}
`;
